export default "__VITE_ASSET__jsjBfxIR__"